import React, { useCallback, memo, useMemo } from 'react';
import { TouchableOpacity } from 'react-native';
import { hitSlopS } from 'design-system/values';
import { IconBell } from 'design-system/icons';
import { useAppSelector } from 'store/hooks';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import { selectIsInvestWalkthroughActive } from 'reducers/selectors/walkthrough';
import { selectHasPendingStockAlert } from '../reducers/selectors';
const StockAlertButton = ({ assetId }) => {
    const navigation = useMainStackNavigation();
    const isInvestWalkthroughActive = useAppSelector(selectIsInvestWalkthroughActive);
    const hasPendingStockAlert = useAppSelector((state) => selectHasPendingStockAlert(state, assetId));
    const onButtonPress = useCallback(() => {
        if (assetId) {
            if (hasPendingStockAlert) {
                navigation.navigateDeprecated('InvestStockAlertScreen', { assetId });
                return;
            }
            navigation.navigateDeprecated('InvestSetStockAlertScreen', { assetId });
        }
    }, [assetId, hasPendingStockAlert]);
    const color = useMemo(() => {
        if (isInvestWalkthroughActive) {
            return hasPendingStockAlert ? 'brandOnModal' : 'primaryOnModal';
        }
        return hasPendingStockAlert ? 'brand' : 'primary';
    }, [hasPendingStockAlert, isInvestWalkthroughActive]);
    return (<TouchableOpacity hitSlop={hitSlopS} onPress={onButtonPress} disabled={isInvestWalkthroughActive}>
      <IconBell alt={!hasPendingStockAlert} colorKey={color}/>
    </TouchableOpacity>);
};
export default memo(StockAlertButton);
